import SectionHead from './SectionHead'

const BENEFITS = [
  {
    title: 'A working prompt',
    description:
      'Built from your own documentation and your own workflow, tested during the session, ready to paste into Claude or ChatGPT.',
  },
  {
    title: 'Shared expectations',
    description:
      'The whole team has seen where AI helps and where it falls over, so nobody is promising or fearing the wrong thing.',
  },
  {
    title: 'Documentation you did not have',
    description:
      'Even with the AI switched off, writing the process down improves onboarding and keeps knowledge out of one person’s head.',
  },
  {
    title: 'A method you can run again',
    description:
      'The five stages work on any workflow. Run them again for the next process your team wants to hand off.',
  },
]

export default function BenefitsGrid() {
  return (
    <section className="bg-stone py-14 md:py-16">
      <div className="mktg-container">
        <SectionHead
          mark="SECT. 05"
          title="What you leave with"
          note="Every session ends with something you can open, edit and reuse."
        />

        <ol className="ledger max-w-3xl">
          {BENEFITS.map((b) => (
            <li key={b.title} className="flex gap-4 p-5 md:p-6">
              <span className="waypoint mt-2 shrink-0" aria-hidden="true" />
              <div>
                <h3 className="font-display text-lg text-navy mb-1">{b.title}</h3>
                <p className="text-navy/70 text-sm md:text-base leading-relaxed">
                  {b.description}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
